import { tsValidateArray, tsValidateBoolean, tsValidateDynamicObject, tsValidateNumber, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { PermissionDBGroup } from '../../consts.js';
import { tsValidateStringWithDashesAndSlash, validateProjectId } from '../../validators.js';
const Validator_ModifiableProps = {
    projectId: validateProjectId,
    path: tsValidateStringWithDashesAndSlash,
    accessLevelIds: tsValidateArray(tsValidateUniqueId, false),
    deprecated: tsValidateBoolean(false),
    onlyForApplication: tsValidateBoolean(false),
};
const Validator_GeneratedProps = {
    _auditorId: tsValidateString(),
    _accessLevels: tsValidateDynamicObject(tsValidateNumber(), tsValidateString(), false),
};
export const DBDef_PermissionAPI = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'permissions--api',
    frontend: {
        group: PermissionDBGroup,
        name: 'api',
    },
    backend: {
        name: 'permissions--api',
    },
    entityName: 'PermissionsAPI',
    uniqueKeys: ['projectId', 'path'],
    dependencies: {
        projectId: {
            dbKey: 'permissions--project',
            fieldType: 'string'
        },
        accessLevelIds: {
            dbKey: 'permissions--level',
            fieldType: 'string[]'
        }
    }
};
//# sourceMappingURL=db-def.js.map